import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import styles from "../../../../customer/styles/customerStyles.module.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import { updateStore } from "../../../../../api/store";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  height: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "20px 50px",
  borderRadius: "10px",
};

export default function StoreStatusUpdateModal({ storeId }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [status, setStatus] = useState(false);
  const dispatch = useDispatch();

  return (
    <>
      <Icon
        icon="material-symbols:edit-square-outline"
        width="20"
        height="20"
        style={{ cursor: "pointer", margin: "0px 8px" }}
        onClick={handleOpen}
      />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style} className="">
            <>
              <h2
                className={styles.welcome_popup}
                style={{ marginBottom: "20px" }}
              >
                Update Status
              </h2>
              <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
                Select Status
              </InputLabel>
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  sx={{
                    margin: "10px 0",
                    width: "100%",
                    // height: "38px",
                    textAlign: "left",
                  }}
                  // renderValue={
                  //   issue !== ""
                  //     ? undefined
                  //     : () => <Placeholder>Choose disute issue</Placeholder>
                  // }
                  value={status || "Select status"}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="true">Active</MenuItem>
                  <MenuItem value={"false"}>Inactive</MenuItem>
                </Select>
              </FormControl>

              <Button
                variant="lightblue"
                disabled={status === ""}
                sx={{
                  width: "auto",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  dispatch(
                    updateStore({
                      storeId: storeId,
                      updatePayload: { is_active: status === "false" ? false: true },
                    })
                  );
                  handleClose();
                }}
              >
                Update
              </Button>
            </>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
